import httpClient from './httpClient'

export default {
  getAll(customerId, filters) {
    let query = 'filters'
    Object.entries(filters).forEach(el => {
      if (el[1] !== '' && el[1] !== undefined && el[1] !== null) query += `&${el[0]}=${el[1]}`
    })
    let url = `vehicles`
    if (customerId !== 0) url += `/customer/${customerId}`
    if (query !== '') url += '?' + query
    return httpClient.get(url).then(r => r.data)
  },
  get(id) {
    return httpClient.get(`vehicle/${id}`).then(r => r.data)
  },
  getTco(id) {
    return httpClient.get(`vehicle/${id}/tco`).then(r => r.data)
  },
  create(params) {
    return httpClient.post('vehicle', params).then(r => r.data)
  },
  update(params) {
    return httpClient.put('vehicle', params).then(r => r.data)
  },
  updateStatus(ids, status) {
    return httpClient.put(`vehicles?status=${status}&ids=${ids.join(',')}`).then(r => r.data)
  },
  giveBack(id, params) {
    return httpClient.put(`vehicle/${id}`, params).then(r => r.data)
  },
  assignDriver(id, params) {
    return httpClient.put(`vehicle/${id}`, params).then(r => r.data)
  },
  remove(ids) {
    return httpClient.delete(`vehicles?ids=${ids.join(',')}`).then(r => r.data)
  }
}
